import { StyledCard } from '@app/components/StyledCard';
import { reportNameMessages } from '@app/modules/audit/modules/reports/constants';
import { AuditReportsAodRuleReportTypeEnum } from '@mi-front/api-v2';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
const REPORT_TYPES = [
  AuditReportsAodRuleReportTypeEnum.AUDIT_GIP_STATUS,
  AuditReportsAodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT,
] as const;

export function ReportDefinitions() {
  const { $t } = useIntl();

  return (
    <StyledCard
      title={$t({
        id: 'audit.reportDefinitions.templatesTitle',
        defaultMessage: 'Plantillas',
      })}
    >
      <List>
        {REPORT_TYPES.map((reportType) => {
          const reportNameMessage = reportNameMessages[reportType];
          const reportName = reportNameMessage ? $t(reportNameMessage) : reportType;

          return (
            <ListItem key={reportType} disablePadding>
              <ListItemButton
                component={Link}
                to={`/audit/config/report-definitions/${reportType}`}
              >
                <ListItemIcon>
                  <DesignServicesIcon />
                </ListItemIcon>
                <ListItemText
                  primary={$t(
                    {
                      id: 'audit.reportDefinitions.templatesForReport',
                      defaultMessage: 'Plantillas para reporte {name}',
                    },
                    { name: reportName },
                  )}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </StyledCard>
  );
}
